import { render, staticRenderFns } from "./AssignCourierModal.vue?vue&type=template&id=49399e41&"
import script from "./AssignCourierModal.vue?vue&type=script&lang=js&"
export * from "./AssignCourierModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignCourierModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports